import { useTranslation } from 'react-i18next'

/**
 * Shown wherever plans are listed while `BILLING_ENABLED` is off on the API.
 *
 * The plan catalogue stays visible on purpose — users should still see what is coming —
 * but every action that would start a checkout is disabled, and the backend rejects those
 * calls with `BILLING_DISABLED` regardless.
 */
export function BillingDisabledBanner({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: compact ? '10px 14px' : '14px 18px',
        borderRadius: 12,
        border: '1px solid var(--accent-border)',
        background: 'color-mix(in srgb, var(--accent) 8%, transparent)',
        color: 'var(--text)',
        fontSize: 13,
        lineHeight: 1.5,
        maxWidth: 980,
        margin: '0 auto',
        boxSizing: 'border-box',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 16, lineHeight: 1.2 }}>
        🚧
      </span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <strong style={{ fontWeight: 700 }}>
          {t('billing.disabled.title', 'Pagamentos em desenvolvimento')}
        </strong>
        <span style={{ opacity: 0.75 }}>
          {t(
            'billing.disabled.description',
            'A contratação de planos ainda está sendo finalizada. Por enquanto todos os workspaces seguem no plano gratuito.',
          )}
        </span>
      </div>
    </div>
  )
}
